import { Trans } from 'react-i18next';
import styles from '../../userVerificationModal.module.css';
import Button from '../../../button/button';
import { ForgotPinProps } from '../../userVerificationModal.types';
import { FC } from 'react';

export const ForgotPinContent: FC<ForgotPinProps> = (props: ForgotPinProps) => (
  <div className={styles.content}>
    <h3 className={styles.oops}>
      <Trans i18nKey={'userVerification.forgotPin'} />
    </h3>
    <p className={styles.description}>
      <Trans i18nKey="userVerification.ifYouAreStaff" />
    </p>
    <Button className={styles.okButton} onClick={props.handleForgotPinModalOk}>
      <Trans i18nKey="userVerification.ok" />
    </Button>
  </div>
);
